import { Box, Typography } from "@mui/material";
import React from "react";

const Footer = () => {
  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: "#f5f5f5",
        textAlign: "center",
        borderTop: "1px solid #ddd",
      }}
    >
      <Typography variant="body2" color="textSecondary">
        © {new Date().getFullYear()} 3Edge Solutions (Talent IQ). All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
